import Api from '@/ultils/api-base'

export default {
   login(body) {
      return Api('POST', 'login', body)
   },
   forgotPass(body) {
      return Api('POST', 'forgotPass', body)
   },
   getListBanners(body) {
      return Api('POST', 'wsGetHotNews', body)
   },
   getListFtthAccountInfo(body) {
      return Api('POST', 'wsGetListFtthAccountInfo', body)
   },
   getFtthAccountInfo(body) {
      return Api('POST', 'wsGetFtthAccountInfo', body)
   },
   getFtthAccountSameCust(body) {// thay thế cho API cũ lấy ftth detail wsGetFtthAccountInfo
      return Api('POST', 'wsGetListAccountFtthSameCust', body)
   },
   getPaymentFTTH(body){
      return Api('POST', 'wsPaymentFTTH', body)
   },
   wsFtthBillsDetail(body) {
      return Api('POST', 'wsFtthBillsDetail', body)
   },
   chanePrepaid(body) {
      return Api('POST', 'wsChanePrepaid', body)
   },
   getFtthPrepaidInfo(body) {
      return Api('POST', 'wsGetFtthPrepaidInfo', body)
   },
   getViewFtthInvoiceStatement(body) {
      return Api('POST', 'wsViewFtthInvoiceStatement', body)
   },
   getListFtthServices(body) {
      return Api('POST', 'wsGetListFtthServices', body)
   },
   getListReceipt(body) {
      return Api('POST', 'wsGetListReceipt', body)
   },
   getViewReceiptInfo(body) {
      return Api('POST', 'wsViewReceiptInfo', body)
   },
   getListInvoice(body) {
      return Api('POST', 'wsGetListInvoice', body)
   },
   getViewInvoiceInfo(body) {
      return Api('POST', 'wsViewInvoiceInfo', body)
   },
   getListInvoiceStatement(body) {
      return Api('POST', 'wsGetListInvoiceStatement', body)
   },
   getViewInvoiceStatement(body) {
      return Api('POST', 'wsViewInvoiceStatement', body)
   },
   getEwalletInfo(body) {
      return Api('POST', 'wsGetEwalletInfo', body)
   },
   changePassword(body) {
      return Api('POST', 'UserChangePassword', body)
   },
   getFtthServiceDetailByServiceCode(body) {
      return Api('POST', 'wsGetFtthServiceDetailByServiceCode', body)
   },
   getProvinces(body) {
      return Api('POST', 'wsGetProvinces', body)
   },
   getDistricts(body) {
      return Api('POST', 'wsGetDistricts', body)
   },
   getPrecinct(body) {
      return Api('POST', 'wsGetPrecincts', body)
   },
   getInfoCust(body) {
      return Api('POST', 'wsGetInfoCust', body)
   },
   orderFtth(body) {
      return Api('POST', 'ptg_orderFtth', body)
   },
   getInforPromotionFtth100(body) {
      return Api('POST', 'wsInforPromotionFtth100', body)
   },
    getPromotionUseFTTH(body) {
        return Api('POST', 'wsPromotionUseFTTH', body)
   },
    getVerifyOtp(body) {
        return Api('POST', 'wsVerifyOtp', body)
   },
   prepareInfoPackage(body) {
      return Api('POST', 'wsPrepareInfoPackage', body,false)
   },
   getListSubType(body) {
      return Api('POST', 'wsGetListSubType', body,false)
   },
   getAmountInfo (body) {
      return Api('POST', 'wsGetAmountInfo', body,false)
   },
   confirmChangePackage (body) {
      return Api('POST', 'wsConfirmChangePackage', body,false)
   },
   getUmoneyOTP (body) {
      return Api('POST', 'wsGetUmoneyOTP', body,false)
   },
   changePackageAndSubType (body) {
      return Api('POST', 'wsChangePackageAndSubType', body,false)
   },
   historyComplain (body) {
      return Api('POST', 'wsHistoryComplain', body,false)
   },
   getComplainGroup (body) {
      return Api('POST', 'wsGetComplainGroup', body,true)
   },
   getComplainTypeByGroupId (body) {
      return Api('POST', 'wsGetComplainTypeByGroupId', body,true)
   },
   ftthAccountComplain (body) {
      return Api('POST', 'wsFtthAccountComplain', body,true)
   },
   getListContract (body) {
      return Api('POST', 'WS_callAPIBccs3', body)
   },
   getInternetManagementOTP (body) {
      return Api('POST', 'WS_getOTPInternetManagement', body)
   },
   checkInternetManagementOTP (body) {
      return Api('POST', 'WS_checkOTPInternetManagement', body)
   },
   getDetailInternet (body) {
      return Api('POST', 'WS_detailInternet', body)
   },
   getTrafficStatistic (body) {
      return Api('POST', 'WS_statisticLatest', body)
   },
   updatePassword (body) {
      return Api('POST', 'WS_changePasswordDevice', body)
   },
   setSchedule (body) {
      return Api('POST', 'WS_scheduleDevice', body)
   },
   getListSchedule (body) {
      return Api('POST', 'WS_listSchedule', body)
   },
   updateSchedule (body) {
      return Api('POST', 'WS_updateSchedule', body)
   },
   deleteSchedule (body) {
      return Api('POST', 'WS_deleteSchedule', body)
   },
   rebootDevice (body) {
      return Api('POST', 'WS_rebootDevice', body)
   },
   searchRpt (body) {
      return Api('POST', 'WS_searchRptInternetManagement', body)
   },
   getTechnicalStaffByAccount(body) {
      return Api('POST', 'getTechnicalStaffByAccount', body)
   },
   wsGetAccountFtthInfo(body) {
      return Api('POST', 'wsGetAccountFtthInfo', body)
   },
   wsGetListPackageFtth(body) {
      return Api('POST', 'wsGetListPackageFtth', body)
   },
   wsDetailPackageFtth(body) {
      return Api('POST', 'wsDetailPackageFtth', body)
   },
   wsConfirmChangeFtth(body) {
      return Api('POST', 'wsConfirmChangeFtth', body)
   },
   wsGetEwalletInfo(body) {
      return Api('POST', 'wsGetEwalletInfo', body)
   },
   wsGetOtpWithoutPassword(body) {
      return Api('POST', 'wsGetOtpWithoutPassword', body)
   },
   wsSubmitChangeFtth(body) {
      return Api('POST', 'wsSubmitChangeFtth', body)
   },
   wsSubmitMerchant(body) {
      return Api('POST', 'wsSubmitMerchant', body)
   },
   wsCreateOrderChangeFtth(body) {
      return Api('POST', 'wsCreateOrderChangeFtth', body)
   },
   wsCreateOrderClearDebit(body) {
      return Api('POST', 'wsCreateOrderClearDebit', body)
   },
   wsGetPaymentDebit(body) {
      return Api('POST', 'wsGetPaymentDebit', body)
   },
   wsClearDebit(body) {
      return Api('POST', 'wsClearDebit', body)
   },
   wsDebitAccountUmoney(body) {
      return Api('POST', 'wsDebitAccountUmoney', body)
   },
   wsGetPlace(body) {
      return Api('POST', 'wsGetPlace', body)
   },
   wsOcrCard(body) {
      return Api('POST', 'wsOcrCard', body)
   },
   wsOcrPassport(body) {
      return Api('POST', 'wsOcrPassport', body)
   },
   wsChangePasswordFtth(body) {
      return Api('POST', 'wsChangePasswordFtth', body)
   },
   wsCreateMapAccount(body) {
      return Api('POST', 'wsCreateMapAccount', body)
   },
   wsGetListAccountMyUnitel(body) {
      return Api('POST', 'wsGetListAccountMyUnitel', body)
   },
   wsDeleteMapAccount(body) {
      return Api('POST', 'wsDeleteMapAccount', body)
   },
   wsGetCustomerPayment(body) {
      return Api('POST', 'wsGetCustomerPayment', body)
   },
}
